import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const permissionEntityAdapter: EntityAdapter = {
  entity: "permission",
  adjustUpdatePayload: (_result, values, ctx) => ({
    ...values,
    codename: ctx.presetValues.codename,
    content_type: ctx.presetValues.content_type,
  }),
  defaultSort: { sort: "content_type", tableSort: "content_type", descending: false },
  toolbar: { hidesCreateArea: true },
};
